import React from 'react';
import Barcode from 'react-barcode';
import { Col, Label, Row } from 'reactstrap';

import logo from '../../assets/img/brand/logobf.png';
import { dateHourToBr, dateToBr } from '../../util/date';

import { GridDinamico } from '@newspacebpo/newspace-react-grid-filter-bfveic';

const getDossieNumberKey = (tpProtocolo) => (tpProtocolo === 'Cartão Consignado' ? 'NumeroProposta' : 'NumeroContrato');
const ImprimirProtocoloPrint = React.forwardRef(({
  protocolo,
  tpProtocolo,
  envelope,
  dataGer,
  responsavelGer,
  statusRec,
  items = [],
}, ref) => (
  <div ref={ref} className="protocolo-consulta__imprimir__print">
    <Row>
      <Col xs="3">
        <img className="protocolo-consulta__imprimir__print__logo" src={logo} alt="Logo" />
      </Col>
      <Col>
        <div className="protocolo-consulta__imprimir__print__barcode">
          <Barcode
            value={protocolo}
            displayValue={false}
            format="CODE128"
            height={50}
            width={3}
          />
        </div>
      </Col>
    </Row>
    <Row className="mt-2 top60">
      <Col xs={4} sm={4} md={4}>
        <Label>Protocolo: </Label>
        <Label className="m-1">{protocolo}</Label>
      </Col>
      <Col xs={4} sm={4} md={4}>
        <Label>Tipo Protocolo: </Label>
        <Label className="m-1">{tpProtocolo}</Label>
      </Col>
      <Col xs={4} sm={4} md={4}>
        <Label>Envelope: </Label>
        <Label className="m-1">
          {envelope}
        </Label>
      </Col>
    </Row>

    <Row className="mt-2">
      <Col xs={4} sm={4} md={4}>
        <Label>Data/Hora da Geração: </Label>
        <Label className="m-1">
          {dateHourToBr(dataGer)}
        </Label>
      </Col>
      <Col xs={4} sm={4} md={4}>
        <Label>Responsável pela Geração:</Label>
        <Label className="m-1">{responsavelGer}</Label>
      </Col>
      <Col xs={4} sm={4} md={4}>
        <Label>Status: </Label>
        <Label className="m-1">{statusRec}</Label>
      </Col>
      <Col sm={12} md={12}>
        <Label className="label"><strong>Total de Contratos: </strong></Label>
        <Label className="m-1 label"><strong>{items.length}</strong></Label>
      </Col>
    </Row>

    <GridDinamico pagination={false} />
  </div>
));

export default ImprimirProtocoloPrint;
